module.exports = __webpack_public_path__ + "static/img/open_svip.6e8b560.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/img2/open_svip.png
// module id = j9GD
// module chunks = 1